import { Integrations } from 'constants/integrations';

export const podTicketUrl = (
  psa: Integrations | undefined,
  psaId: number,
  ticketId: string,
): string | null => {
  switch (psa) {
    case Integrations.Halo:
      return `/HaloPod/${psaId}/ticket/${Number(ticketId)}`;
    case Integrations.ConnectWise:
      return `/ConnectwisePod/${psaId}/ticket/${Number(ticketId)}`;
    case Integrations.Autotask:
      return `/AutotaskPod/${psaId}/ticket/${ticketId}`;
    case Integrations.FreshService:
      return `/FreshServicePod/${psaId}/ticket/${Number(ticketId)}`;
    case Integrations.Syncro:
      return `/SyncroPod/${psaId}/ticket/${Number(ticketId)}`;
    case Integrations.SuperOps:
      return `/SuperOpsPod/${psaId}/ticket/${ticketId}`;
    case Integrations.Zendesk:
      return `/ZendeskPod/${psaId}/ticket/${Number(ticketId)}`;
    default:
      return null;
  }
};

export default podTicketUrl;
